import { render, staticRenderFns } from "./RobotAssistant.vue?vue&type=template&id=74d5f06a&scoped=true&"
import script from "./RobotAssistant.vue?vue&type=script&lang=js&"
export * from "./RobotAssistant.vue?vue&type=script&lang=js&"
import style0 from "./RobotAssistant.vue?vue&type=style&index=0&id=74d5f06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d5f06a",
  null
  
)

export default component.exports